import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const velocityReportEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-next-gen-reports-velocity-entrypoint" */ './src'),
	),
	getPreloadProps: () => ({}),
});
